import { PaperClipIcon } from "@heroicons/react/24/outline";
import React from "react";
import LoadingSpinner from "../../shared-components/LoadingSpinner";

type Props = {
  title: string;
  values: string[] | { value: string; link?: string }[];
  isLoading?: boolean;
  placeholder?: string;
};

const PersonInfoLabel = (props: Props) => {
  const hasValues = props.values.length > 0 && !props.isLoading;
  return (
    <div className="flex flex-col w-[17rem]">
      <span className="text-gray-800 font-bold">{props.title}</span>
      {props.isLoading && <LoadingSpinner />}
      {!props.isLoading &&
        hasValues &&
        props.values.map((pivot, idx) => (
          <React.Fragment key={idx}>
            {typeof pivot === "string" && (
              <span className="text-gray-500 overflow-hidden text-ellipsis whitespace-nowrap">
                {pivot}
              </span>
            )}
            {typeof pivot === "object" && "link" in pivot && pivot.link && (
              <a
                href={pivot.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 overflow-hidden text-ellipsis whitespace-nowrap relative hover:underline pl-5"
              >
                {pivot.value}
                <span className="absolute top-1 left-0 text-black">
                  <PaperClipIcon className="w-4 h-4" />
                </span>
              </a>
            )}
          </React.Fragment>
        ))}
      {!hasValues && (
        <span className="text-gray-500">{props.placeholder ?? "None"}</span>
      )}
    </div>
  );
};

export const PersonInfoLabelCustom = (props: {
  title: string;
  children: React.ReactNode;
}) => {
  return (
    <div className="flex flex-col w-[17rem]">
      <span className="text-gray-800 font-bold">{props.title}</span>
      {props.children}
    </div>
  );
};

export default PersonInfoLabel;
